import React from 'react';
import { Box, Typography } from '@mui/material';
import { EmojiObjects as BulbIcon } from '@mui/icons-material';

/**
 * "¿Por qué esta opción es #N?" transparency bullets.
 * Reads ranking.why_bullets_es from item.
 * Uses theme tokens - no hardcoded hex.
 */
const WhyBullets = ({ item, rank }) => {
  const bullets = item?.ranking?.why_bullets_es;
  if (!bullets || bullets.length === 0) return null;

  return (
    <Box
      sx={{
        bgcolor: 'neutral.50',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        px: 2.5,
        py: 2,
        my: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <BulbIcon sx={{ color: 'warning.main', fontSize: '1.1rem' }} />
        <Typography variant="caption" sx={{ fontWeight: 700, color: 'primary.main', letterSpacing: 0.3 }}>
          {rank != null ? `¿Por qué esta opción es #${rank}?` : '¿Por qué recomendamos esto?'}
        </Typography>
      </Box>
      {bullets.map((b, i) => (
        <Typography key={i} variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7, pl: 0.5 }}>
          • {b}
        </Typography>
      ))}
    </Box>
  );
};

export default WhyBullets;
